import React from 'react';
import {
  getGenreString,
  convertSecondsToMinutes,
  useOffer,
} from '../../utils/helpers';

import MediaDetails from '../MediaDetails';

import { IMedia } from '../../utils/models';
import { TAccessServiceType } from '../../@types/Access';
import AccessServiceBadge from '../AccessServiceBadge';
import { KiteIcon, KiteLink } from '@kite/react-kite';
export interface MovieDetailsProps {
  media: IMedia;
  accessServices?: TAccessServiceType[];
}

const MovieDetails = ({
  media: {
    title,
    imageUrl,
    description,
    descriptors,
    genres,
    ratings,
    duration,
    releaseYear,
    topCast,
    offer,
  },
  accessServices,
}: MovieDetailsProps) => {
  const currentOffer = useOffer(offer);

  const { startTime, endTime } = currentOffer;

  const rating =
    ratings && ratings.find((rating) => rating.agency === 'mpaa')?.rating;
  const genreString = getGenreString(genres);
  const director = topCast?.find((person) => person.role === 'DIRECTOR')?.name;

  const statLine = (
    <div className="stat-line">
      {/* Genres */}
      {genreString && <span className="stat-line__segment">{genreString}</span>}

      {/* Duration */}
      {duration && (
        <span className="stat-line__segment">
          {convertSecondsToMinutes(duration)} Mins
        </span>
      )}

      {/* Release Year */}
      {releaseYear && <span className="stat-line__segment">{releaseYear}</span>}

      {/* Rating */}
      {rating && (
        <span className="stat-line__segment">
          {(rating as any)?.value || rating}
        </span>
      )}
    </div>
  );

  const postDescription = (
    <div className="post-description">
      {/* Director */}
      {director && (
        <span className="post-description__detail">
          <span className="label">Director</span>
          {director}
        </span>
      )}
      {/* {!!accessServices?.length && (
        <span className="footer__access-cta">
          Accessible features are available for this title on{' '}
          <KiteLink
            className="screenshot-access-block__description-link"
            href="https://access-app.spectrum.net/explore"
            type="standalone"
          >
            Spectrum Access 
            <KiteIcon
              className="access-cta__link-icon"
              icon="ki-chevron-right"
              size="14px"
            />
          </KiteLink>
        </span>
      )} */}
    </div>
  );

  return (
    <MediaDetails
      mediaType="movie"
      title={title}
      imageUri={`${imageUrl}?sourceType=colorHybrid&twccategory=Poster&width=257`}
      description={description}
      statLine={statLine}
      postDescription={postDescription}
      moods={descriptors?.moods}
      dates={{ startTime, endTime }}
      accessibleFeatures={accessServices || []}
    />
  );
};

export default MovieDetails;
